import { render, staticRenderFns } from "./FormDistillationColumnA.vue?vue&type=template&id=09c2f060&scoped=true&"
import script from "./FormDistillationColumnA.vue?vue&type=script&lang=js&"
export * from "./FormDistillationColumnA.vue?vue&type=script&lang=js&"
import style0 from "./FormDistillationColumnA.vue?vue&type=style&index=0&id=09c2f060&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c2f060",
  null
  
)

export default component.exports